<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <a-spin :spinning="loading">
            <navbar :back_path="back_path || '/privilege'" :hide_search="true" :navbar_sub_visible="$device != 'mobile'" active_screen="privilege" :content_title="privilege_detail.title" />
            <div v-if="$device == 'mobile'" style="overflow-y: scroll; overflow-x: hidden">
                <div class="ml-20 mr-20 mb-20">
                    <center>
                        <img :src="privilege_detail.image" class="br-12" style="width: 100%" />
                    </center>
                    <img :src="privilege_detail.logo_full" style="width: 48px; margin: 0 auto; position: absolute; top: 8px; right: 28px" />
                    <div style="margin-top: 20px; justify-content: space-between; display: flex">
                        <label class="title">
                            {{ privilege_detail.brand }}
                        </label>
                        <img @click="toggleFavorite(privilege_detail)" :src="!privilege_detail.button_favorite ? '/resources/images/icon-star-select.png' : '/resources/images/icon-star.png'" style="width: 20px; height: 20px; margin: auto 0; margin-right: 10px" />
                    </div>
                    <div class="mt-16" v-if="privilege_detail.display_remaining_privilege != 'n'">
                        <div class="progress-bar">
                            <div :style="{ width: gpbw(privilege_detail.display_remaining_used, privilege_detail.display_remaining_total) }"></div>
                        </div>
                        <div class="text-right mt-8">
                            <span class="fs-18 fw-600 red">
                                {{ privilege_detail.display_remaining_text }}
                            </span>
                        </div>
                    </div>
                    <div class="mt-16 br-8" style="background-color: rgb(255, 230, 230); border: 1px solid rgb(255, 177, 177)">
                        <label class="ml-16 mr-16 mt-16 mb-16 fs-20"> {{ privilege_detail.plivilege }}</label>
                    </div>
                    <label class="mt-16 fs-18" v-html="privilege_detail.description"> </label>
                    <template v-if="privilege_detail.packages && privilege_detail.packages.length > 0">
                        <div style="width: 100%" v-for="(privilege_detail_package, privilege_detail_package_index) in privilege_detail.packages" :key="privilege_detail_package_index">
                            <div
                                style="background-color: #fff; padding: 8px"
                                @click="
                                    r('/privilege-detail-uniqueprivilegetrue', {
                                        priv_id: privilege_detail_package.priv_id,
                                        package_id: privilege_detail_package.package_id,
                                    })
                                "
                            >
                                <div style="width: 40%; display: inline-block">
                                    <img :src="privilege_detail_package.image" style="width: 100%; margin: 0; vertical-align: unset" />
                                </div>
                                <div style="width: 60%; display: inline-block; padding: 0; padding-left: 8px; vertical-align: top">
                                    <label class="fs-20 fw-600 single-line mb-0">
                                        {{ privilege_detail_package.package_name }}
                                    </label>
                                    <label class="fs-18 c-gray two-lines mb-0" style="color: #000 !important">
                                        {{ privilege_detail_package.description }}
                                    </label>
                                    <div style="text-align: center" v-if="privilege_detail.display_button || (!privilege_detail.display_button && privilege_detail.display_button_type == 'm')">
                                        <a-button class="text-center primary-btn ant-button-label-custom fs-18" style="border-radius: 0; width: 144px" @click="openConfirm($event, privilege_detail_package)" :disabled="!privilege_detail.display_button && privilege_detail.display_button_type == 'm'">
                                            <strong>กดรับสิทธิ์</strong>
                                        </a-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <hr class="mt-4" />
                        <div style="text-align: center; width: 100%; margin: 16px 0px 16px">
                            <div style="width: 100%; border-radius: 8px; padding: 2px">
                                <div style="background: #fff; border-radius: 100px">
                                    <!--  -->
                                    <a-button
                                        style="width: 50%"
                                        size="large"
                                        class="text-center br-20"
                                        @click="step = 'เงื่อนไข'"
                                        :style="{
                                            'background-color': step == 'เงื่อนไข' ? '#CC0000' : '#FFFFFF',
                                            'border-radius': '8px',
                                            display: 'inline-block',
                                        }"
                                    >
                                        <span
                                            class="fs-20 fw-600"
                                            :style="{
                                                color: step == 'เงื่อนไข' ? '#FFFFFF' : '#2e2f2e',
                                            }"
                                            >เงื่อนไข</span
                                        >
                                    </a-button>
                                    <a-button
                                        style="width: 50%"
                                        size="large"
                                        class="text-center br-20"
                                        @click="step = 'สาขา'"
                                        :style="{
                                            'background-color': step == 'สาขา' ? '#CC0000' : '#FFFFFF',
                                            'border-radius': '8px',
                                            display: 'inline-block',
                                        }"
                                    >
                                        <span
                                            class="fs-20 fw-600"
                                            :style="{
                                                color: step == 'สาขา' ? '#FFFFFF' : '#2e2f2e',
                                            }"
                                            >สาขา</span
                                        >
                                    </a-button>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div v-if="step == 'เงื่อนไข'">
                        <span class="THSarabunNew fs-24 fw-300" v-html="privilege_detail.condition" />
                    </div>
                    <div v-else>
                        <span class="THSarabunNew fs-24 fw-300" v-html="privilege_detail.branch" />
                    </div>
                    <div style="margin-bottom: 64px"></div>
                    <!-- <div class="text-center" style="margin: 0; margin-top: 32px; padding-bottom: 20px; position: fixed; border-radius: 25px 25px 0 0; bottom: 0px; background-color: rgb(255, 255, 255); margin: -20px; width: 100%" v-if="privilege_detail.remain > 0 && privilege_detail.display_button == true && privilege_detail.unique_privilege == false"> -->
                    <div class="text-center" style="margin: 0; margin-top: 32px; padding-bottom: 20px; position: fixed; border-radius: 25px 25px 0 0; bottom: 0px; background-color: rgb(255, 255, 255); margin: -20px; width: 100%; max-width: 480px" v-if="privilege_detail.display_button || (!privilege_detail.display_button && privilege_detail.display_button_type == 'm')">
                        <label class="fs-18 fw-600" style="display: block; padding: 8px" v-if="privilege_detail.remain_display">
                            ท่านมีสิทธิ์คงเหลือ <span class="color-red">{{ privilege_detail.remain }} สิทธิ์ </span></label
                        >
                        <a-button size="large" class="text-center w-90 bg-red br-20" @click="modalGetRight" :disabled="!privilege_detail.display_button && privilege_detail.display_button_type == 'm'">
                            <span class="fs-20 color-white">กดรับสิทธิ์</span>
                        </a-button>
                    </div>
                </div>
            </div>
            <div v-else style="background-color: #fff; width: 100vw; position: relative">
                <div class="row">
                    <div class="col-5">
                        <center style="margin: 16px">
                            <img :src="privilege_detail.image" style="width: 100%" />
                        </center>
                    </div>
                    <div class="col-7">
                        <img :src="privilege_detail.logo_full" style="width: 48px; margin: 0 auto; position: absolute; top: 8px; right: 8px" />
                        <div style="margin-top: 20px; justify-content: space-between; display: flex">
                            <label class="title">
                                {{ privilege_detail.title }}
                            </label>
                            <img @click="toggleFavorite(privilege_detail)" :src="!privilege_detail.button_favorite ? '/resources/images/icon-star-select.png' : '/resources/images/icon-star.png'" style="width: 20px; height: 20px; margin: auto 0; margin-right: 10px" />
                        </div>
                        <div class="mt-16" v-if="privilege_detail.display_remaining_privilege != 'n'">
                            <div class="progress-bar">
                                <div :style="{ width: gpbw(privilege_detail.display_remaining_used, privilege_detail.display_remaining_total) }"></div>
                            </div>
                            <div class="text-right mt-8">
                                <span class="fs-18 fw-600 red">
                                    {{ privilege_detail.display_remaining_text }}
                                </span>
                            </div>
                        </div>
                        <div class="mt-16 mb-16 br-8" style="background-color: rgb(255, 230, 230); border: 1px solid rgb(255, 177, 177); margin: 0px 8px">
                            <label class="ml-16 mr-16 mt-16 mb-16 fs-20"> {{ privilege_detail.plivilege }}</label>
                        </div>
                        <label class="description" v-html="privilege_detail.description"> </label>
                        <template v-if="privilege_detail.packages && privilege_detail.packages.length > 0">
                            <div style="width: 100%" v-for="(privilege_detail_package, privilege_detail_package_index) in privilege_detail.packages" :key="privilege_detail_package_index">
                                <div
                                    style="background-color: #fff; padding: 8px"
                                    @click="
                                        r('/privilege-detail-uniqueprivilegetrue', {
                                            priv_id: privilege_detail_package.priv_id,
                                            package_id: privilege_detail_package.package_id,
                                        })
                                    "
                                >
                                    <div style="width: 40%; display: inline-block">
                                        <img :src="privilege_detail_package.image" style="width: 100%; margin: 0; vertical-align: unset" />
                                    </div>
                                    <div style="width: 60%; display: inline-block; padding: 0; padding-left: 8px; vertical-align: top">
                                        <label class="fs-20 fw-600 single-line mb-0">
                                            {{ privilege_detail_package.package_name }}
                                        </label>
                                        <label class="fs-18 c-gray two-lines mb-0" style="color: #000 !important">
                                            {{ privilege_detail_package.description }}
                                        </label>
                                        <div style="text-align: center" v-if="privilege_detail.display_button || (!privilege_detail.display_button && privilege_detail.display_button_type == 'm')">
                                            <a-button class="text-center primary-btn ant-button-label-custom fs-18" style="border-radius: 0; width: 144px" @click="openConfirm($event, privilege_detail_package)" :disabled="!privilege_detail.display_button && privilege_detail.display_button_type == 'm'">
                                                <strong>กดรับสิทธิ์</strong>
                                            </a-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div style="text-align: center; width: 100%; padding: 16px; margin: 16px 0 0 0">
                                <div style="width: 100%; background-color: #bebebe; border-radius: 8px; padding: 2px">
                                    <div
                                        :style="{
                                            width: '50%',
                                            'background-color': step == 'เงื่อนไข' ? '#fff' : 'transparent',
                                            'border-radius': '8px',
                                            display: 'inline-block',
                                        }"
                                        @click="step = 'เงื่อนไข'"
                                    >
                                        <label style="font-size: 16px; font-weight: 600; margin: 0"> เงื่อนไข </label>
                                    </div>
                                    <div
                                        :style="{
                                            width: '50%',
                                            'background-color': step == 'สาขา' ? '#fff' : 'transparent',
                                            'border-radius': '8px',
                                            display: 'inline-block',
                                        }"
                                        @click="step = 'สาขา'"
                                    >
                                        <label style="font-size: 16px; font-weight: 600; margin: 0"> สาขา </label>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div v-if="step == 'เงื่อนไข'">
                            <label class="description" v-html="privilege_detail.condition" />
                        </div>
                        <div v-else>
                            <label class="description" v-html="privilege_detail.branch" />
                        </div>
                    </div>
                </div>
                <!-- <div class="row text-center" style="margin: 0; margin-top: 32px; padding-bottom: 16px; position: sticky; bottom: 0; background-color: #fff; box-shadow: 0 10px 0 #fff, 0 -10px 20px #fff; justify-content: center" v-if="privilege_detail.remain > 0 && privilege_detail.display_button == true && privilege_detail.unique_privilege == false"> -->
                <div class="row text-center" style="margin: 0; margin-top: 32px; padding-bottom: 16px; position: sticky; bottom: 0; background-color: #fff; box-shadow: 0 10px 0 #fff, 0 -10px 20px #fff; justify-content: center" v-if="privilege_detail.display_button || (!privilege_detail.display_button && privilege_detail.display_button_type == 'm')">
                    <label class="fs-18" style="color: red !important; display: block; padding: 8px" v-if="privilege_detail.remain_display"> ท่านมีสิทธิ์คงเหลือ {{ privilege_detail.remain }} สิทธิ์ </label>
                    <a-button size="large" class="text-center primary-btn ant-button-label-custom" style="border-radius: 0; width: 144px; font-size: 16px" @click="modalGetRight" :disabled="!privilege_detail.display_button && privilege_detail.display_button_type == 'm'">
                        <strong>กดรับสิทธิ์</strong>
                    </a-button>
                </div>
            </div>
            <div v-if="$device != 'mobile'" class="copyright-section-space"></div>
            <div v-if="$device != 'mobile'" class="copyright-section">© Copyright SCG Debenture Club. All Rights Reserved.</div>
            <modal-form ref="modalForm" :key="modal_visible" :visible="modal_visible" :data="modal_data" @on-save="onModalSave" @on-cancel="onModalCancel" />
        </a-spin>
    </a-spin>
</template>
<script>
import store from 'store';
import navbar from '../../components/navbar';
import modalForm from './../privilege-choice/modalForm';
export default {
    components: {
        navbar,
        modalForm,
    },
    data: function () {
        return {
            getting_data: true,
            loading: false,
            modal_visible: false,
            modal_data: {},
            privilege_detail: {},
            step: 'เงื่อนไข',
            priv_id: this.$route.query.priv_id,
            package_id: null,
            choice_id: null,
            back_path: this.$route.query.back_path,
        };
    },
    mounted() {
        this._mounted();
        console.log('this.$route.query', this.$route.query);
    },
    methods: {
        _mounted: function () {
            this.getPrivilegeDetail(() => (this.getting_data = false));
        },
        toggleFavorite(privilege_detail) {
            var url;
            if (!privilege_detail.button_favorite) {
                url = '/api/favorite/delete';
            } else {
                url = '/api/favorite/add';
            }
            this.loading = true;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: url,
                    data: {
                        xid: privilege_detail.priv_id,
                        type: 'privilege',
                    },
                    callback: (res) => {
                        console.log('res', res);
                        if (res && res.result == 'complete') {
                            this.getPrivilegeDetail();
                        } else {
                            const complete = {
                                title: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                if (key) {
                                    console.log('value[0]', value[0]);
                                    complete.title += value[0];
                                }
                            }
                            this.$confirm({
                                title: complete.title,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                        }
                        this.loading = false;
                    },
                },
            });
        },
        onModalSave() {
            this.modal_visible = false;
            this.package_id = null;
            this.choice_id = this.modal_data.choice ? this.modal_data.choice.choice_id : null;
            this.getPrivilegeGenerate(() => (this.loading = false));
        },
        onModalCancel() {
            this.modal_visible = false;
        },
        getPrivilegeDetail: function (callback = null) {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/privilege/detail',
                    data: {
                        priv_id: this.priv_id,
                    },
                    callback: (res) => {
                        if (res) {
                            this.privilege_detail = res;
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        modalGetRight() {
            if (this.privilege_detail.choices.length > 1) {
                this.$router.replace({
                    path: '/privilege-choice',
                    query: { priv_id: this.priv_id },
                });
            } else {
                this.modal_data.choice = this.privilege_detail.choices[0];
                this.modal_data.choice.count_time = this.privilege_detail ? this.privilege_detail.count_time : 0;
                this.modal_data.step = 'confirm';
                this.modal_visible = true;
                console.log('  this.modal_data', this.modal_data);
                console.log('  this.modal_visible', this.modal_visible);
            }
        },
        openConfirm(e, privilege_detail_package) {
            this.priv_id = privilege_detail_package.priv_id;
            this.package_id = privilege_detail_package.package_id;
            e.preventDefault();
            e.stopPropagation();
            this.$confirm({
                title: 'รับสิทธิ์',
                message: `ท่านประสงค์เลือกสิทธิประโยชน์ ${privilege_detail_package.package_name} หลังจากท่านทำการเลือกรับสิทธิประโยชน์แล้ว ไม่สามารถแก้ใขหรือสามารถเปลี่ยนแปลงได้ทุกกรณี กรุณายืนยันอีกครั้งเพื่อรับสิทธิ์`,
                button: {
                    no: 'ยกเลิก',
                    yes: 'ยืนยัน',
                },
                callback: (confirm) => {
                    if (confirm) {
                        this.getPrivilegeGenerate(() => (this.loading = false));
                    }
                },
            });
        },
        getPrivilegeGenerate: function (callback = null) {
            this.loading = true;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/privilege/generate',
                    data: {
                        priv_id: this.priv_id,
                        package_id: this.package_id,
                        choice_id: this.choice_id,
                    },
                    callback: (res) => {
                        console.log('generate res-->', res);
                        if (res && res.result == 'errors') {
                            console.log('error---->');
                            const complete = {
                                title: '',
                            };
                            for (const [, value] of Object.entries(res.errors)) {
                                complete.title += value[0];
                            }
                            // if (this.$mode == 'production') {
                            this.modal_visible = true;
                            this.modal_data.step = 'error_generate';
                            this.modal_data.message = complete.title;
                            // }
                        } else {
                            store.set('privilege_generate', res);
                            this.r('/privilege-generate', {
                                priv_id: this.priv_id,
                                package_id: this.package_id,
                            });
                        }
                        if (typeof callback == 'function') callback();
                    },
                },
            });
        },
    },
};
</script>
<style scoped>
.slide {
    background-color: transparent;
    width: 100%;
    text-align: center;
}
.title {
    font-size: 20px;
    font-weight: 700;
    margin: 8px 0 0 0;
    color: #cc0000 !important;
}
.description {
    font-size: 16px;
    font-weight: 300;
    color: #000 !important;
    /* display: -webkit-box; */
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}
.description-read-all {
    font-size: 16px;
    font-weight: 300;
    margin: 0 0 0 16px;
    color: #707070 !important;
}
.read-all {
    font-size: 14px;
    font-weight: 300;
    margin: 8px 0 8px 0;
    color: #707070 !important;
}
.half-circle {
    width: 50px;
    height: 25px; /* as the half of the width */
    background-color: #fff;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    /* border: 10px solid gray; */
    border-top: 0;
    box-shadow: #707070 0px 25px 40px 0px;
    margin: 0 auto;
}
/* .vue-confirm-dialog {
}
.vue-confirm-dialog .vc-container .vc-text-grid .vc-title {
  font-size: 16px !important;
}
.vc-title {
  font-size: 16px !important;
} */
</style>